(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hd-countdown"] && !Shopify.designMode) return;
  try {
    class HdCountdown extends HTMLElement {
    connectedCallback() {
      this.target = parseInt(this.dataset.target, 10);
      const serverNow = parseInt(this.dataset.serverNow, 10);
      this.offset = serverNow - Math.floor(Date.now() / 1000);
      this.digits = this.querySelectorAll('[data-unit]');
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    tick() {
      const now = Math.floor(Date.now() / 1000) + this.offset;
      let remaining = Math.max(0, this.target - now);
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      const pad = (n) => String(n).padStart(2, '0');
      const sep = this.hasAttribute('data-spaced') ? ' : ' : ':';
      this.digits.forEach((el) => {
        const unit = el.dataset.unit;
        if (unit === 'all') {
          el.textContent = [pad(days), pad(hours), pad(minutes), pad(seconds)].join(sep);
        } else {
          el.textContent = pad({ days, hours, minutes, seconds }[unit]);
        }
      });
      const reloadAt = parseInt(this.dataset.reloadAt, 10);
      if (reloadAt && now >= reloadAt) {
        const key = 'hd-reloaded-' + reloadAt;
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, '1');
          window.location.reload();
        }
      }
      if (remaining === 0) {
        clearInterval(this.timer);
      }
    }
  }
  if (!customElements.get('hd-countdown')) {
    customElements.define('hd-countdown', HdCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
